/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  ArrowUpOutlined,
  ContainerOutlined,
  DeleteOutlined,
  EditOutlined,
  MenuOutlined,
  PlusOutlined,
  RetweetOutlined,
} from '@ant-design/icons';
import {
  Button,
  Dropdown,
  Input,
  Menu,
  Modal,
  Progress,
  Select,
  Table,
  Tag,
} from 'antd';
import Axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import colorsDark from '../../assets/colors/dark';
import LogEventGateway from '../../components/LogEventGateway';
import { StateTag } from '../../components/StateTag';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import AddGatewayComponent from './AddGateway';
import EditGatewayComponent from './EditGateway';
import ExpandData from './ExpandData';
import './index.scss';
// import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import { beeXLogger } from '../../helpers/logger';

const { Search } = Input;
const { Option } = Select;
const progressColors = (percent) =>
  percent > 80
    ? colorsDark.$errors
    : percent > 60
      ? colorsDark.$warning
      : colorsDark.$online;

const GatewayPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [timeRequest, setTimeRequest] = useState();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(null);
  const [ipAddress, setIpAddress] = useState('0.0.0.0');

  const [serialInternalGateways, setSerialInternalGateway] = useState();
  const [gateways, setGateways] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const {
    isAuth,
    gateways: gatewayPage,
    addDeviceData,
    activeDeviceData,
    namespace,
    userId,
    dataUser,
  } = useSelector((state) => state);
  const [addDeviceReturn, setAddDeviceReturn] = useState(addDeviceData);
  const [activeDeviceReturn, setActiveDeviceReturn] =
    useState(activeDeviceData);
  const [key, setKey] = useState(Math.random());
  const [keyTableGateway, setKeyTableGateway] = useState(Math.random());
  const [dataSearchGateway, setDataSearchGateway] = useState();
  const [dataSelectSearch, setDataSelectSearch] = useState('name');
  const [dataSort, setDataSort] = useState({
    field: 'state',
    order: 'descend',
  });
  const [isModalVisibleLog, setIsModalVisibleLog] = useState(false);
  const [dataGatewayEvent, setDataGatewayEvent] = useState();
  const [dataKeyLog, setDataKeyLog] = useState(Math.random());

  useEffect(() => {
    setTimeRequest(new Date().getTime());
    return () => {
      setTimeRequest(null);
      setVisibleAdd(false);
      setVisibleEdit(false);
      setIpAddress(null);
      setSerialInternalGateway(null);
      setGateways({
        data: [],
        pagination: {},
        loading: false,
      });
      setAddDeviceReturn(null);
      setActiveDeviceReturn(null);
    };
  }, []);

  useEffect(() => {
    if (gatewayPage && gatewayPage.timeRequest === timeRequest) {
      setGateways((state) => ({
        ...state,
        loading: false,
        data: gatewayPage.data,
        pagination: {
          ...state.pagination,
          total: gatewayPage.totalSize,
        },
      }));
    }
  }, [gatewayPage, timeRequest]);

  useEffect(() => {
    async function getInternalGateway(link, serial) {
      try {
        let result = await Axios.get(link);
        return result.status === 200 && result.data.serial === serial;
      } catch (error) {
        return false;
      }
    }
    if (gatewayPage && ipAddress) {
      setSerialInternalGateway(
        gatewayPage?.data
          ?.filter((gateway) => {
            if (
              ipAddress &&
              gateway.state === 1 &&
              gateway.ipAddress &&
              gateway.ipAddress === ipAddress &&
              gateway.localAddress &&
              gateway.localAddress.length > 0
            ) {
              return getInternalGateway(
                `http://${gateway.localAddress}:${gateway.portScan}/info`,
                gateway.serial,
              );
            }
            return false;
          })
          .map((gateway) => gateway.serial),
      );
    }
  }, [gatewayPage, ipAddress]);

  useEffect(() => {
    if (isAuth === 1 && timeRequest && namespace) {
      setGateways((state) => ({ ...state, loading: true }));
      let data = {
        deviceType: 'gateway',
        page: 0,
        size: 10,
        timeRequest,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace, timeRequest]);

  const handleTableChange = useCallback(
    (pagination, _, sort) => {
      const { field, order } = sort;
      setDataSort({
        order,
        field,
      });
      setKeyTableGateway(Math.random());
      setGateways((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        loading: true,
      }));

      let data = {
        deviceType: 'gateway',
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest,
        namespace,
        field,
        order,
      };
      if (dataSearchGateway) {
        data.name = dataSearchGateway;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, timeRequest, dataSearchGateway],
  );

  useEffect(() => {
    setAddDeviceReturn(addDeviceData);
  }, [addDeviceData]);
  useEffect(() => {
    setActiveDeviceReturn(activeDeviceData);
  }, [activeDeviceData]);

  const onReload = useCallback(() => {
    setKeyTableGateway(Math.random());
    let data = {
      deviceType: 'gateway',
      page: 0,
      size: 10,
      timeRequest,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  }, [dispatch, namespace, timeRequest]);

  const onExpandData = useCallback(
    (record) => {
      const { deviceType, targetId, serial } = record;

      if ((record && !record.extends) || (record.extends && !record.extends)) {
        let data = {
          deviceType,
          targetId,
          serial,
          namespace,
        };

        beeXLogger.debug('OK: ', data);

        let dataObj = {
          appServiceType: SERVICE.GET_DEVICE_INFO_EXTRA,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };

        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  const onRequireActiveDevice = useCallback(
    (serial) => {
      if (serial && serial.length > 0) {
        let data = {
          serial,
          namespace,
        };

        let dataObj = {
          appServiceType: SERVICE.REQUIRE_ACTIVE_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );
  const onAddDevice = useCallback(
    (serial, activationCode) => {
      if (
        serial &&
        serial.length > 0 &&
        activationCode &&
        activationCode.length > 0
      ) {
        let data = {
          serial,
          activationCode,
          namespace,
        };

        let dataObj = {
          appServiceType: SERVICE.ADD_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );

  const onUpdateDevice = useCallback(
    (data, requestId) => {
      if (data) {
        let dataObj = {
          appServiceType: SERVICE.UPDATE_DEVICE,
          requestId,
          body: JSON.stringify({
            ...data,
            namespace,
          }),
        };
        beeXLogger.debug('🚀 ~ UPDATE_DEVICE ~ body:', dataObj.body);

        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace],
  );
  const handleRemoveGateway = (name, serial) => {
    Modal.error({
      title: 'Unsupported function',
      content: 'This function is coming soon...',
    });
  };

  const onSearch = (name) => {
    setDataSearchGateway(name?.trim());
    setKeyTableGateway(Math.random());
    setGateways((state) => ({
      ...state,
      pagination: {
        ...state.pagination,
        current: 1,
        pageSize: 10,
      },
      loading: true,
    }));
    let data = {
      deviceType: 'gateway',
      page: 0,
      size: 10,
      timeRequest,
      namespace,
    };
    if (name?.trim()) {
      if (dataSelectSearch === 'name') {
        data.name = name?.trim();
      } else {
        data.tags = name?.trim();
      }
    }
    let dataObj = {
      appServiceType:
        dataSelectSearch === 'tag' && name?.trim()
          ? SERVICE.LIST_DEVICE_BY_TAGS
          : SERVICE.LIST_ALL_DEVICE_BY_PAGE,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  const showModal = () => {
    setIsModalVisibleLog(true);
  };

  const handleOk = () => {
    setIsModalVisibleLog(false);
  };

  const handleCancel = () => {
    setIsModalVisibleLog(false);
    setDataKeyLog(Math.random);
  };

  return (
    <div className="box-management-component">
      <Modal
        title={t('Add new gateway')}
        visible={visibleAdd}
        onCancel={() => {
          setVisibleAdd(false);
          setKey(Math.random());
        }}
        footer={null}
        okButtonProps={{ style: { display: 'none' } }}
      >
        {visibleAdd && (
          <AddGatewayComponent
            key={key}
            dispatch={dispatch}
            addDeviceReturn={addDeviceReturn}
            activeDeviceReturn={activeDeviceReturn}
            onRequireActiveDevice={onRequireActiveDevice}
            onAddDevice={onAddDevice}
            onUpdate={onUpdateDevice}
            handleAddSuccessful={() => {
              onReload();
              setKey(Math.random());
              return setVisibleAdd(false);
            }}
          />
        )}
      </Modal>
      <Modal
        title={t('Update gateway')}
        visible={!!visibleEdit}
        footer={null}
        onCancel={() => setVisibleEdit(null)}
        okButtonProps={{ style: { display: 'none' } }}
      >
        {!!visibleEdit && (
          <EditGatewayComponent
            onFinish={() => {
              setVisibleEdit(null);
              return onReload();
            }}
            onCancel={() => setVisibleEdit(null)}
            onUpdate={onUpdateDevice}
            data={visibleEdit}
          />
        )}
      </Modal>
      <div className="box-management-header">
        <div className="title-box-management">
          <div className="text-title">{t('Gateway')}</div>
        </div>
        <div className="btn-add-box">
          <Select
            value={dataSelectSearch}
            style={{ width: '100px' }}
            onChange={(value) => setDataSelectSearch(value)}
          >
            <Option value="name">
              <span style={{ textTransform: 'none' }}>{t('Name')}</span>
            </Option>
            <Option value="tag">
              <span style={{ textTransform: 'none' }}>{t('Tag')}</span>
            </Option>
          </Select>
          <Search
            placeholder={
              dataSelectSearch === 'name'
                ? t('Search gateway by name')
                : t('Search gateway by tag')
            }
            onSearch={onSearch}
            style={{ width: 250, marginRight: '16px' }}
            allowClear
          />
          <Button
            icon={<PlusOutlined />}
            size="middle"
            onClick={() => setVisibleAdd((state) => !state)}
          >
            {t('Add device')}
          </Button>
        </div>
      </div>
      <div className="box-management-data">
        <Table
          key={keyTableGateway}
          expandable={{
            expandedRowRender: (record) => (
              <ExpandData
                progressColors={progressColors}
                addable={
                  userId === record.ownerId ||
                  (dataUser && dataUser.role === 'admin')
                }
                expands={
                  record &&
                  record.expands && { ...record.expands, ...record.performance }
                }
                record={record}
                namespace={namespace}
                isInternal={
                  serialInternalGateways &&
                  serialInternalGateways.some(
                    (serial) => serial === record.serial,
                  )
                }
              />
            ),
            rowExpandable: (record) => record.targetId,
          }}
          onExpand={(expanded, record) => expanded && onExpandData(record)}
          dataSource={
            gateways &&
            gateways.data &&
            gateways.data.map((log, key) => ({
              ...log,
              key,
            }))
          }
          pagination={gateways && gateways.pagination}
          loading={(gateways && gateways.loading) || !serialInternalGateways}
          onChange={handleTableChange}
          columns={[
            {
              title: t('Name'),
              dataIndex: 'name',
              key: 'name-gateway',
              defaultSortOrder:
                dataSort?.field === 'name' ? dataSort?.order : undefined,
              sorter: (a, b) => a.name.localeCompare(b.name),
            },
            {
              title: t('Tag'),
              dataIndex: 'tags',
              key: 'tags-gateway',
              render: (value) => {
                const tags = value?.split(';').filter(Boolean) || [];

                if (tags.length > 0) {
                  return tags.map((tag) => (
                    <Tag key={tag} color={colorsDark.$online}>
                      {tag}
                    </Tag>
                  ));
                }

                return '';
              },
            },
            {
              title: t('IP Address'),
              dataIndex: 'ipAddress',
              key: 'ipAddress-gateway',
            },
            {
              title: t('Local Address'),
              dataIndex: 'localAddress',
              key: 'localAddress-gateway',
            },
            {
              title: t('State'),
              dataIndex: 'state',
              key: 'state-gateway',
              defaultSortOrder:
                dataSort?.field === 'state' ? dataSort?.order : undefined,
              width: 120,
              render: (value) => <StateTag state={value} />,
              sorter: (a, b) => a.state - b.state,
            },
            {
              title: t('Bandwidth'),
              dataIndex: 'performance',
              key: 'network-gateway',
              width: 120,
              render: (value) => `${value.networkIn + value.networkOut} Kbps`,
            },
            {
              title: t('Temperature'),
              dataIndex: 'performance',
              key: 'temperature-gateway',
              width: 120,
              render: (value) => `${value.temperature} °C`,
            },
            {
              title: t('CPU'),
              dataIndex: 'performance',
              key: 'cpu-gateway',
              render: (value) => (
                <Progress
                  percent={value.cpu}
                  strokeColor={progressColors(value.cpu)}
                  status={value.cpu > 90 && 'exception'}
                  format={(percent) => {
                    return `${percent}%`;
                  }}
                />
              ),
            },
            {
              title: t('RAM'),
              dataIndex: 'performance',
              key: 'ram-gateway',
              render: (value) => (
                <Progress
                  percent={value.ram}
                  strokeColor={progressColors(value.ram)}
                  status={value.ram > 80 && 'exception'}
                  format={(percent) => {
                    return `${percent}%`;
                  }}
                />
              ),
            },
            {
              title: t('Action'),
              key: 'actions ',
              width: 200,
              render: (record) => (
                <div className="gateway-actions">
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item
                          key="0"
                          onClick={() => setVisibleEdit(record)}
                        >
                          <span>
                            <EditOutlined />
                            {t('Update')}
                          </span>
                        </Menu.Item>
                        <Menu.Item key="1">
                          <span>
                            <RetweetOutlined />
                            {t('Restart')}
                          </span>
                        </Menu.Item>
                        <Menu.Item key="2">
                          <span>
                            <ArrowUpOutlined />
                            {t('Upgrade')}
                          </span>
                        </Menu.Item>
                        <Menu.Item
                          key="3"
                          onClick={() => {
                            showModal();
                            setDataGatewayEvent(record);
                          }}
                        >
                          <span>
                            <ContainerOutlined />
                            {t('History event')}
                          </span>
                        </Menu.Item>
                      </Menu>
                    }
                    trigger={['click']}
                    placement="bottomRight"
                  >
                    <span className="edit-button">
                      <MenuOutlined /> {t('Option')}
                    </span>
                  </Dropdown>
                  <div
                    className="edit-button"
                    onClick={() =>
                      handleRemoveGateway(record.name, record.serial)
                    }
                  >
                    <DeleteOutlined /> {t('Remove')}
                  </div>
                </div>
              ),
            },
          ]}
        />
      </div>
      <Modal
        title={t('History event') + ` (${dataGatewayEvent?.name})` ?? ''}
        className="modal-event-camera"
        style={{ top: 64 }}
        key={dataKeyLog}
        visible={isModalVisibleLog}
        onOk={handleOk}
        onCancel={handleCancel}
        width="85%"
        footer={false}
      >
        <LogEventGateway dataDevice={dataGatewayEvent} />
      </Modal>
    </div>
  );
};

export default GatewayPage;
